<template>
  <div>
    <v-select
      class="text-body-2 mx-2"
      :style="$vuetify.breakpoint.mdAndDown ? 'width: 95px' : 'width: 150px'"
      background-color="langSwitch"
      v-model="selectedCurrency"
      :items="currencies"
      menu-props="auto"
      hide-details
      :solo="$vuetify.breakpoint.mdAndDown"
      :flat="$vuetify.breakpoint.mdAndDown"
      :rounded="$vuetify.breakpoint.lgAndUp"
      dense
      v-on:change="changeCurrency"
      style="z-index: 999999"
    >
    </v-select>
  </div>
</template>

<script>
import { getSavedCurrency, saveCurrency } from "../util/currencyHelper";

export default {
  data: () => {
    return {
      selectedCurrency: getSavedCurrency() || "USD",
    };
  },
  computed: {
    currencies() {
      return (this.$store.state.supportedCurrencies || [{ symbol: "USD" }]).map(
        x => x.symbol
      );
    },
  },
  methods: {
    changeCurrency(value) {
      saveCurrency(value);
      location.reload();
    },
  },
};
</script>
